import { DAY_KEYS, DAY_LABELS } from "@/lib/businessHours";

export const BusinessHoursEditor = ({ hours, onChange }) => {
  const updateDay = (day, patch) => onChange({ ...hours, [day]: { ...hours[day], ...patch } });

  const applyMondayToWeekdays = () => {
    const monday = hours.monday;
    const next = { ...hours };
    ["tuesday", "wednesday", "thursday", "friday"].forEach((day) => { next[day] = { ...monday }; });
    onChange(next);
  };

  return (
    <div data-testid="org-settings-business-hours">
      <div className="mb-3 flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500">Business Hours</p>
        <button
          type="button"
          onClick={applyMondayToWeekdays}
          data-testid="org-settings-apply-monday-btn"
          className="text-xs font-bold text-[#0052FF] hover:underline"
        >
          Apply Monday to weekdays
        </button>
      </div>
      <div className="space-y-2">
        {DAY_KEYS.map((day) => {
          const info = hours[day] || {};
          return (
            <div key={day} className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 p-3 dark:border-white/10" data-testid={`org-settings-hours-row-${day}`}>
              <span className="w-24 shrink-0 text-sm font-semibold text-slate-700 dark:text-slate-200">{DAY_LABELS[day]}</span>
              <label className="flex items-center gap-2 text-xs font-semibold text-slate-500 dark:text-slate-400">
                <input
                  type="checkbox"
                  checked={!info.closed}
                  onChange={(e) => updateDay(day, e.target.checked ? { closed: false, open: info.open || "09:00", close: info.close || "17:00" } : { closed: true })}
                  data-testid={`org-settings-hours-open-toggle-${day}`}
                />
                Open
              </label>
              {!info.closed ? (
                <div className="flex items-center gap-2">
                  <input
                    type="time"
                    value={info.open || ""}
                    onChange={(e) => updateDay(day, { open: e.target.value })}
                    data-testid={`org-settings-hours-open-${day}`}
                    className="rounded-lg border border-slate-300 px-2 py-1.5 text-sm dark:border-white/15 dark:bg-white/5 dark:text-white"
                  />
                  <span className="text-slate-400">–</span>
                  <input
                    type="time"
                    value={info.close || ""}
                    onChange={(e) => updateDay(day, { close: e.target.value })}
                    data-testid={`org-settings-hours-close-${day}`}
                    className="rounded-lg border border-slate-300 px-2 py-1.5 text-sm dark:border-white/15 dark:bg-white/5 dark:text-white"
                  />
                </div>
              ) : (
                <span className="text-sm font-semibold text-slate-400 dark:text-slate-500">Closed</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
